import { Carousel } from 'antd';
import slider1 from '../../assets/images/slider1.png';
import slider2 from '../../assets/images/slider2.png';
import slider3 from '../../assets/images/slider3.png';
import LOGO from '../../assets/svg/vastu-logo.svg';
import './auth.less';

const AuthSlider = () => {
  return (
    <div className="carousal-wrapper">
      <img src={LOGO} alt="logo" className="main-logo"></img>
      <Carousel autoplay>
        <div className="slider-item">
          <img src={slider3} alt="Slider 1" className="slider-image-third" />
          <div className="slider-text">
            <div className="heading title-md semibold ">
              Craft Your Ideal Home
            </div>
            <div className="content body-base">
              Generate a personalised Vastu report for your floor plan.
            </div>
          </div>
        </div>
        <div className="slider-item">
          <img src={slider2} alt="Slider 2" className="slider-image" />
          <div className="slider-text">
            <div className="heading title-md semibold">
              Simple Steps, Big Impact
            </div>
            <div className="content body-base">
              Upload your floor plan and quickly get your property's Vastu
              score.
            </div>
          </div>
        </div>
        <div className="slider-item">
          <img src={slider1} alt="Slider 1" className="slider-image" />
          <div className="slider-text">
            <div className="heading title-md semibold">Live in Harmony</div>
            <div className="content body-base">
              Take informed decisions to optimize your home's Vastu balance.
            </div>
          </div>
        </div>
      </Carousel>
    </div>
  );
};

export default AuthSlider;
